module.exports = __webpack_public_path__ + "static/img/img1.527b3ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/yxsc/img1.png
// module id = ZXSD
// module chunks = 1